import React from 'react'
import { AiOutlineMail, AiOutlineShareAlt } from 'react-icons/ai';
import { BiFilterAlt } from 'react-icons/bi';
import { BsChat } from 'react-icons/bs';
import { FiSettings } from 'react-icons/fi';
import { MdDesktopWindows } from 'react-icons/md';
import { FaChessQueen } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const FormWizardChild = () => {

    const {event_option} = useSelector((state => state.createEvent))
    const location = useLocation()

    const eventOption       =   location.pathname === '/event/options'||
                                location.pathname === '/event/social' ||
                                location.pathname === '/event/email' ||
                                location.pathname === '/event/sms' ||
                                location.pathname === '/event/digital-prop' ||
                                location.pathname === '/event/microsite' ||
                                location.pathname === '/event/filter'

    const eventSocial       =   location.pathname === '/event/social'||
                                location.pathname === '/event/email' ||
                                location.pathname === '/event/sms' ||
                                location.pathname === '/event/digital-prop'||
                                location.pathname === '/event/microsite' ||
                                location.pathname === '/event/filter'

    const eventEmail        =   location.pathname === '/event/email'||
                                location.pathname === '/event/sms' ||
                                location.pathname === '/event/digital-prop'||
                                location.pathname === '/event/microsite' ||
                                location.pathname === '/event/filter'

    const eventTextSMS      =   location.pathname === '/event/sms' ||
                                location.pathname === '/event/digital-prop'||
                                location.pathname === '/event/microsite' ||
                                location.pathname === '/event/filter'

    const eventDigitalProp  =   location.pathname === '/event/digital-prop'||
                                location.pathname === '/event/microsite' ||
                                location.pathname === '/event/filter'

    const eventMicroSite    =   location.pathname === '/event/microsite' ||
                                location.pathname === '/event/filter'
                           
    const eventFilter       =   location.pathname === '/event/filter'

    
    return (
        <>
            <div className="my-3">
                    <ul className="form__step">
                    {/* data_capture: false */}
                  

                        <li className={`${eventOption ? 'active':''}`}>
                            <span className="rounded-btn">
                            <FiSettings size={20} />
                            </span>
                        </li>

                        {event_option.social_media === true ? 
                        <li className={`${eventSocial ? 'active':''}`}>
                            <span className="rounded-btn">
                            <AiOutlineShareAlt size={20} />
                            </span>
                        </li>
                        :""}

                        {event_option.email === true ? 
                        <li className={`${eventEmail ? 'active':''}`}>
                            <span className="rounded-btn">
                            <AiOutlineMail size={20} />
                            </span>
                        </li>
                        :""}
                        {event_option.text_messaging === true ? 
                        <li className={`${eventTextSMS ? 'active':''}`}>
                            <span className="rounded-btn">
                            <BsChat size={20} />
                            </span>
                        </li>
                        :""}

                        {event_option.digital_props === true ? 
                        <li className={`${eventDigitalProp ? 'active':''}`}>
                            <span className="rounded-btn">
                            <FaChessQueen size={20} />
                            </span>
                        </li>
                        :""}

                        {event_option.microsite === true ? 
                        <li className={`${eventMicroSite ? 'active':''}`}>
                            <span className="rounded-btn">
                            <MdDesktopWindows size={20} />
                            </span>
                        </li>
                        :""}

                        {event_option.filters === true && (
                        <li className={`${eventFilter ? 'active':''}`}>
                            <span className="rounded-btn">
                            <BiFilterAlt size={20} />
                            </span>
                        </li>)}
                     

                        {/* <li className={`${formStepChildTwo ? 'active':''}`}>
                            <span className="rounded-btn">
                            <IoImageOutline size={20} />
                            </span>
                        </li>

                        <li className={`${formStepChildThree ? 'active':''}`}>
                            <span className="rounded-btn">
                            <BsPhone size={20} />
                            </span>
                        </li> */}
                    </ul>
            </div>
            
        </>
    )
}

export default FormWizardChild
